import React from 'react';
import { withRouter } from 'react-router';
import { ROUTES } from '../../constants/Routes';

const UpgradeToPro = ({ history }) => {
  const handleUpgrade = () => {
    history.push('/renew/select-plan');
  };

  return (
    <div className="upgrade-message-banner w-100">
      <div className="container">
        <div className="row">
          <div className="col-md-12 d-flex justify-content-between">
            <p className="pt-3 d-inline ml-3">
              Upgrade to Pro to get access to Growth Add-Ons support
            </p>
            <button className="btn ml-4" onClick={handleUpgrade}>Upgrade Plan</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(UpgradeToPro);



// WEBPACK FOOTER //
// ./src/components/Banners/upgradeToPro.js